import Translations from '../common/translations';

global.setTranslations = translations => {
  global.translations = new Translations(
    translations,
    'en',
    document.documentElement.lang
  );
};



// WEBPACK FOOTER //
// ./app/javascript/packs/translations.js